import { render, staticRenderFns } from "./SpecialistDashboardAnalytics.vue?vue&type=template&id=312bbff8&scoped=true&"
import script from "./SpecialistDashboardAnalytics.vue?vue&type=script&lang=js&"
export * from "./SpecialistDashboardAnalytics.vue?vue&type=script&lang=js&"
import style0 from "./SpecialistDashboardAnalytics.vue?vue&type=style&index=0&id=312bbff8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312bbff8",
  null
  
)

export default component.exports